import * as type from "../../types/API/reportColumns";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
  message: ''
};

export const reportColumnslPrefrenceReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.REPORT_COLUMNS_PREFRENCE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.REPORT_COLUMNS_PREFRENCE_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
        mesage: action.payload.responseData?.message
      };
    case type.REPORT_COLUMNS_PREFRENCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
